import { core, toEnumString } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

export function fetchAvailableForType(
  taggableClassName: core.MetaTag.TaggableClassName
): ApiAction {
  const { MetaTag } = protos;
  const fetchType = toEnumString(MetaTag.TaggableClassName, taggableClassName);
  return {
    TockApi: {
      getListProto: `/meta-tags?type=${fetchType}`,
      type: AppConstants.METATAG_FETCH,
      context: fetchType,
    },
  };
}
